import { render } from "./skillUpload.vue?vue&type=template&id=06678531&scoped=true"
import script from "./skillUpload.vue?vue&type=script&lang=js"
export * from "./skillUpload.vue?vue&type=script&lang=js"

import "./skillUpload.vue?vue&type=style&index=0&id=06678531&scoped=true&lang=css"

import exportComponent from "C:\\Users\\NASTYFACT\\Desktop\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06678531"]])

export default __exports__